import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `length` property of an object.
export default shallowProperty('length');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/_getLength.js
// module id = 41
// module chunks = 106